import {Link} from "react-router-dom";
import * as React from "react";
import {cx} from "emotion";

import "./sub-view-more.scss";

import {cs}   from "@Common/react/chain-services";
import {sort} from "@Common/utils/collections";

import {Tooltip}          from "../../common/tool-tip";
import {FlexInternalLink} from "../common/components/flex-internal-link";

export const rSubViewMore = (sub, {viewMode, parent: cat}) => cs(
    ({}) => (
        FlexInternalLink({
            href: sub.link,
            target: sub.newTab?"_blank":undefined,
            className: cx("sub-view-more-item-7de", viewMode),
            "xd-qa-type": "subcat",
            style: {backgroundImage: `url('${sub.image}')`},
            to: `/cat/${cat.id}/sub/${sub.id}`,
            children: <>
                <Tooltip/>

                <div className="content">
                    <div
                        className="name"
                        data-tip={sub.name}
                    >
                        {sub.name}
                    </div>

                    <div className="details">
                        {sort(sub.child, (style: any) => style.seq).map((style: any) => (
                            <Link
                                to={`/cat/${cat.id}/sub/${sub.id}?filter=${style.id}`}
                                className="line"
                                key={style.id}
                                data-tip={style.name}
                                xd-qa-type="link"
                                xd-qa-name={style.name}
                            >
                                {style.name}
                            </Link>
                        ))}
                    </div>
                </div>
            </>,
        })
    ),
);